<script>
import {mapActions, mapState} from 'vuex';
    
export default {
    props: {
        translationPrefix: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            interval: undefined
        }
    },
    computed: {
        ...mapState({
            timer: state => state.alert.timer,
            message: state => state.alert.message
        })
    },
    created() {
        this.interval = setInterval(() => {
            if(this.timer > 0) {
                this.countdown();
            }
        }, 1000);
    },
    destroyed() {
        clearInterval(this.interval)
    },
    methods: {
        ...mapActions({
            countdown: 'alert/countdown'
        }),
    }
}
</script>
<template>
    <transition name="slide-fade">
        <div v-if="timer > 0" :class="'message--' + message.level" class="message">
            <div class="message__content">
                <span v-if="translationPrefix">{{ $t(translationPrefix + '.' + message.message) }}</span>
                <span v-if="!translationPrefix">{{ message.message }}</span>
            </div>
        </div>
    </transition>
</template>



// WEBPACK FOOTER //
// src/components/Alert/Alert.vue